import React, { useContext, useEffect } from 'react'
import { Frame, Modal } from '@react95/core'
import { MerchRegionContext } from 'Providers'

function MerchModalStoreEur({ close }) {
  const { region } = useContext(MerchRegionContext)
  const modalFrameStyle: any = {
    width: '100%',
    maxHeight: '600px',
    backgroundColor: 'white',
    overflowY: 'scroll',
    padding: '8px',
  }

  useEffect(() => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://windoge95.myspreadshop.nl/shopfiles/shopclient/shopclient.nocache.js'
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <Modal
      defaultPosition={{ x: 12, y: 12 }}
      icon={<></>}
      title={region === 'usa' ? 'USA' : 'International'}
      width="80vw"
      height="80vh"
      closeModal={close}
      style={{
        maxHeight: '80%',
        width: '99%',
        minWidth: '640px',
      }}
    >
      <Frame style={modalFrameStyle} id="myShop">
        <a href="https://windoge95.myspreadshop.nl">windoge95</a>
      </Frame>
    </Modal>
  )
}

export default MerchModalStoreEur
